import videojs from 'video.js';
import { initVideoControls } from './video-controls';

function initCloudflareVideos() {
  document.querySelectorAll('video-js.autoDetect').forEach((el, index) => {
    if (el.dataset.cloudflareInit) return;
    el.setAttribute('data-cloudflare-init', '1');

    // Capture the poster fallback sibling BEFORE videojs() runs —
    // initVideoControls re-parents the element into a wrapper div,
    // which destroys the sibling relationship. nextElementSibling keeps
    // the association 1:1 (a parent-scoped query would let a hidden
    // slide player grab the default video's poster).
    const poster = el.nextElementSibling?.classList?.contains('cloudflare-video__poster')
      ? el.nextElementSibling
      : null;

    const player = videojs(el, {
      muted: true,
      loop: true,
      autoplay: true,
      controls: false,
      preload: 'auto',
      playsinline: true,
      fill: true,
      responsive: true,
    });

    if (poster) {
      player.one('playing', () => poster.classList.add('cloudflare-video__poster--hidden'));
    }

    player.ready(() => {
      const promise = player.play();
      if (promise && typeof promise.catch === 'function') {
        promise.catch(() => {});
      }
      initVideoControls([el], `cloudflare-${index}`, { player });
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCloudflareVideos);
} else {
  initCloudflareVideos();
}
